"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.genericAdapter = exports.pydanticAIAdapter = exports.semanticKernelAdapter = exports.microsoftAgentAdapter = exports.geminiAdapter = exports.openAIAdapter = exports.aisdkAdapter = exports.langgraphAdapter = void 0;
exports.selectAdapter = selectAdapter;
const langgraph_1 = require("./langgraph");
const aisdk_1 = require("./aisdk");
const openai_1 = require("./openai");
const gemini_1 = require("./gemini");
const microsoft_agent_1 = require("./microsoft-agent");
const semantic_kernel_1 = require("./semantic-kernel");
const pydantic_ai_1 = require("./pydantic-ai");
const generic_1 = require("./generic");
const adapters = [
    langgraph_1.langgraphAdapter, // Must be before openAI (both use langfuse-sdk scope)
    aisdk_1.aisdkAdapter, // Vercel AI SDK v5 (for all LLM providers like OpenAI, Bedrock, Anthropic, etc.)
    openai_1.openAIAdapter, // OpenAI (Chat Completions & Responses API)
    gemini_1.geminiAdapter, // Gemini/VertexAI format
    microsoft_agent_1.microsoftAgentAdapter, // Microsoft Agent Framework
    pydantic_ai_1.pydanticAIAdapter, // Pydantic AI framework
    // Add more adapters here as needed
    semantic_kernel_1.semanticKernelAdapter, // Microsoft Semantic Kernel - detects by scope.name prefix
    generic_1.genericAdapter,
];
function selectAdapter(ctx) {
    // Explicit override
    if (ctx.framework) {
        const adapter = adapters.find((a) => a.id === ctx.framework);
        if (adapter)
            return adapter;
    }
    // First adapter that matches wins. Detection is best-effort: a throwing
    // adapter is treated as a non-match so I/O preview can fall through.
    for (const adapter of adapters) {
        try {
            if (adapter.detect(ctx)) {
                return adapter;
            }
        }
        catch {
            continue;
        }
    }
    return generic_1.genericAdapter;
}
var langgraph_2 = require("./langgraph");
Object.defineProperty(exports, "langgraphAdapter", { enumerable: true, get: function () { return langgraph_2.langgraphAdapter; } });
var aisdk_2 = require("./aisdk");
Object.defineProperty(exports, "aisdkAdapter", { enumerable: true, get: function () { return aisdk_2.aisdkAdapter; } });
var openai_2 = require("./openai");
Object.defineProperty(exports, "openAIAdapter", { enumerable: true, get: function () { return openai_2.openAIAdapter; } });
var gemini_2 = require("./gemini");
Object.defineProperty(exports, "geminiAdapter", { enumerable: true, get: function () { return gemini_2.geminiAdapter; } });
var microsoft_agent_2 = require("./microsoft-agent");
Object.defineProperty(exports, "microsoftAgentAdapter", { enumerable: true, get: function () { return microsoft_agent_2.microsoftAgentAdapter; } });
var semantic_kernel_2 = require("./semantic-kernel");
Object.defineProperty(exports, "semanticKernelAdapter", { enumerable: true, get: function () { return semantic_kernel_2.semanticKernelAdapter; } });
var pydantic_ai_2 = require("./pydantic-ai");
Object.defineProperty(exports, "pydanticAIAdapter", { enumerable: true, get: function () { return pydantic_ai_2.pydanticAIAdapter; } });
var generic_2 = require("./generic");
Object.defineProperty(exports, "genericAdapter", { enumerable: true, get: function () { return generic_2.genericAdapter; } });
